import React from "react";
import { Label } from "reactstrap";
import CreatableSelect from "react-select/creatable";
import Required from "./Required";

import MyLabel from "./MyLabel";
import { handleSelectChange } from "../../../utils/Utils";

const MyCreateSelect = ({ title, multi, name, placeholder, register,required, watch, errors, setValue, trigger, options ,disabled}) => {
  return (
    <div className="form-group  ">
       <MyLabel name={name} title={title} required={required}/>
      <div className="form-control-wrap">
        <CreatableSelect
          isMulti
          placeholder={placeholder}
          className=""
          id={name}
          {...register(name, {
            required: `Please select ${title}`,
          })}
          onChange={(e) => handleSelectChange(e, name, setValue, trigger)}
          value={watch(name)}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: errors?.[name] ? "red" : "grey",
            }),
          }}
          isDisabled={disabled}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyCreateSelect;
